/**
 * The price a customer actually pays for one unit.
 *
 * The API computes `discountedPrice` server-side against the effective price,
 * so that is always preferred; the manual fallback only covers cart lines
 * saved by an older build of the app, before the field existed.
 *
 * Shared by the cart drawer and checkout so the two can never show different
 * totals for the same basket.
 */
export const effectivePrice = (item) => {
  if (item?.discountedPrice != null) return Number(item.discountedPrice);

  const price = Number(item?.price) || 0;
  const discount = Number(item?.discountValue) || 0;
  if (!item?.discountType || item.discountType === "none" || !discount) {
    return price;
  }
  if (item.discountType === "percentage") {
    return Math.max(0, price - (price * discount) / 100);
  }
  return Math.max(0, price - discount);
};

/** Line total for a cart entry. */
export const lineTotal = (item) =>
  effectivePrice(item) * (Number(item?.foodQty) || 0);

/** True when the item is showing a reduced price. */
export const hasDiscount = (item) =>
  effectivePrice(item) < (Number(item?.price) || 0);
